import Link from "next/link";
import React, { useState } from "react";
import { tailwindClasses } from "./tailwindClasses";

const Cta = ({ mobile, link }) => {
  const { buttons } = tailwindClasses;
  // const router = useRouter();
  const [showNumber, setShowNumber] = useState(false);

  // const redirectPage = useCallback(
  //     (link) => {
  //         if (link) {
  //             router.push(link);
  //         }
  //     },
  //     [router]
  // );

  return (
    <div className="flex">
      <button
        onClick={() => setShowNumber(true)}
        className={`${buttons} hover:bg-[#384148] hover:text-[#e0f3fd] border-r border-r-1 border-[#fff]`}
      >
        {showNumber ? mobile || "NA" : "Show Number"}
      </button>
      {/* <button className={`${buttons} border-l border-l-1 border-[#fff]`} onClick={() => redirectPage(link)}>Show Details</button> */}
      {link ? (
        <Link
          className={`${buttons} hover:bg-[#384148] hover:text-[#e0f3fd] text-center border-l border-l-1 border-[#fff]`}
          href={link}
          target="_blank"
        >
          Show Details
        </Link>
      ) : (
        <span
          className={`${buttons} hover:bg-[#384148] hover:text-[#e0f3fd] text-center border-l border-l-1 border-[#fff] !cursor-default`}
        >
          No Details
        </span>
      )}
    </div>
  );
};

export default Cta;
